module.exports = __webpack_public_path__ + "static/media/arrowRight.9c76c381.svg";